import DeleteAccountResultDialogModule from './delete-account-result-dialog.module'

export default DeleteAccountResultDialogModule
